module.exports = __webpack_public_path__ + "img/add-advertisement-image-icon.160c105c.svg";